import { Table } from '@apex/component-library'
import { Box, Text } from '@chakra-ui/react'
import { isEmpty, uniqueId } from 'lodash'
import React from 'react'
import { AuditTrail as IAuditTrail } from '../../../../api/types'
import { formatDateAndTimeFromString } from '../../../../utils/dateUtil'

export interface AuditTrailProps {
  auditTrail: IAuditTrail[]
}

const columns = [
  {
    key: 'dateAndTime',
    label: 'Date & Time',
    recordField: 'dateAndTime',
  },
  {
    key: 'user',
    label: 'User',
    recordField: 'user',
  },
  {
    key: 'type',
    label: 'Type',
    recordField: 'type',
  },
  {
    key: 'note',
    label: 'Note',
    recordField: 'note',
  },
]

const getTableData = (auditTrail: IAuditTrail[]) => {
  return !isEmpty(auditTrail)
    ? auditTrail.map(audit => ({
        key: uniqueId(),
        dateAndTime: formatDateAndTimeFromString(audit.timestamp, 'M/d/yyyy t'),
        user: audit.username,
        type: audit.type,
        note: audit.comment,
      }))
    : [
        {
          key: 1,
          dateAndTime: 'No audit data found.',
          user: '',
          type: '',
          note: '',
        },
      ]
}

const AuditTrail = ({ auditTrail }: AuditTrailProps) => {
  return (
    <Box id="audit-trail">
      <Box bg="gray.600" color="apex.white" p={3}>
        <Text fontWeight="bold">Audit Trail</Text>
      </Box>
      <Table
        columns={columns}
        data={getTableData(auditTrail)}
        defaultSort={
          !isEmpty(auditTrail)
            ? { field: 'dateAndTime', ascending: false }
            : undefined
        }
      />
    </Box>
  )
}

export default AuditTrail
